import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";

const CATS = [
  { id: "all", label: "All" },
  { id: "fitness", label: "Fitness" },
  { id: "hygiene", label: "Hygiene" },
  { id: "health", label: "Health" },
  { id: "etiquette", label: "Etiquette" },
];

export default function Tips() {
  const { user } = useAuth();
  const [tips, setTips] = useState([]);
  const [cat, setCat] = useState("all");
  const [saved, setSaved] = useState({});

  useEffect(() => {
    api.get(`/tips${cat === "all" ? "" : `?category=${cat}`}`).then((r) => setTips(r.data));
  }, [cat]);

  const save = async (id) => {
    if (!user || typeof user !== "object") {
      toast.error("Sign in to save tips");
      return;
    }
    try {
      await api.post(`/tips/save/${id}`);
      setSaved((s) => ({ ...s, [id]: true }));
      toast.success("Saved to your vault");
    } catch {
      toast.error("Could not save");
    }
  };

  return (
    <section id="tips" data-testid="tips-feed-section" className="py-16 md:py-24 bg-[var(--bg-secondary)] border-y border-[var(--border-subtle)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <div className="eyebrow">The Vault</div>
            <h2 className="font-display text-4xl sm:text-5xl uppercase mt-2">
              Tips that <span className="gold-text">actually move</span> the needle
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button
                key={c.id}
                data-testid={`tips-filter-${c.id}`}
                onClick={() => setCat(c.id)}
                className={`px-4 py-2 rounded-full text-xs font-mono uppercase tracking-widest ${
                  cat === c.id
                    ? "bg-[var(--gold)] text-[#0a0a0e]"
                    : "border border-[var(--border-subtle)] text-[var(--text-secondary)] hover:text-[var(--gold)]"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tips.map((t, i) => (
            <article
              key={t.id}
              data-testid={`tips-card-${i}`}
              className="gr-card p-6 flex flex-col gr-rise"
              style={{ animationDelay: `${i * 40}ms` }}
            >
              <div className="flex items-center justify-between">
                <span className="eyebrow">{t.category}</span>
                <button
                  data-testid={`tip-save-${t.id}`}
                  onClick={() => save(t.id)}
                  className="text-[var(--text-muted)] hover:text-[var(--gold)]"
                >
                  {saved[t.id] ? <BookmarkCheck size={18} /> : <Bookmark size={18} />}
                </button>
              </div>
              <h3 className="font-display text-2xl uppercase mt-3 leading-tight">{t.title}</h3>
              <p className="text-sm text-[var(--text-secondary)] mt-3 leading-relaxed">{t.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
